import React from 'react'
import { MediaPageDisplayProps } from './Interface'
import { Box, useMediaQuery, Grid, Paper, Typography, Link } from '@material-ui/core'
import { Section } from 'components/section'
import { Pdf, Link as LinkIcon } from 'assets/images'
import useStyles from './Styles'

const MediaPageDisplay: React.FC<MediaPageDisplayProps> = ({ medias }) => {
  const classes = useStyles({})
  const isSmall = useMediaQuery('(max-width:834px)')
  const file = medias.find(media => media.mediaType === 'FILE')
  const links = medias.filter(media => media.mediaType === 'LINK')

  const getItemPanel = (item: any, icon: any, sizeProps: any) => {
    const nameDisplay = item ? `${item.name.charAt(0).toUpperCase()}${item.name.slice(1)}` : ''
    return (
      <Grid
        item
        {...sizeProps}
        className={[classes.mt_30, classes.mediaItemPanel, isSmall ? classes.mediaItemPanelSmall : ''].join(' ')}
      >
        <Grid container justify="center">
          <Link target="blank" href={item.url}>
            <Grid className={classes.pdfImageContainer}>
              <img
                id="media-upload-current-item-pdf-icon"
                className={icon === Pdf ? classes.pdfIcon : classes.linkIcon}
                src={icon}
                alt={'Pointr-pdf'}
              />
            </Grid>

            <Grid container justify="center">
              <Typography id="media-upload-current-item-name-label" className={classes.currentMediaFileName}>
                {nameDisplay}
              </Typography>
            </Grid>
          </Link>
        </Grid>
      </Grid>
    )
  }

  return (
    <Box>
      <Section padding="50px 40px 30px 40px" direction={'column'}>
        <Grid
          item
          className={[classes.currentMediaContainer, isSmall ? classes.currentMediaContainerSmall : ''].join(' ')}
        >
          <Paper className={classes.paperCurrentMedia}>
            <Typography variant="subtitle1" id="media-upload-current-file-media-label">
              Media
            </Typography>
            <Grid container direction="row" style={{ width: 'auto' }}>
              {file && getItemPanel(file, Pdf, {})}
              {links && links.map(link => getItemPanel(link, LinkIcon, {}))}
            </Grid>
          </Paper>
        </Grid>
      </Section>
    </Box>
  )
}

export default MediaPageDisplay
